import {HttpStatusCode} from "axios";

export interface ApiMessageHistory {
  id: string;
  httpStatusCode?: HttpStatusCode;
  message?: string;
  messageType?: string;
  createdBy?: string;
  createdDate: Date;
  contentType: ApiMessageHistoryContentType;
}

export interface ApplicationApiMessageHistory extends ApiMessageHistory {
  applicationId: string;
}

export interface ApplicationActivityRecord {
  id: string;
  activityType: string;
  summary?: string;
  detail?: string;
  httpStatusCode?: number;
  contentType?: ApiMessageHistoryContentType;
  createdDate: string;
  createdBy?: string;
  modifiedBy?: string;
}

export enum ApiMessageHistoryContentType
{
  Json,
  Xml,
  PlainText
}